import axios from 'axios'
import apiURI from './Api';

export default class CategoryService {
  async getCategories() {
    const response = await axios.get(`${apiURI}/product/category/all`)
    return response.data;
  }

    async postUploadImage(token, image) {
    let data = new FormData();
    data.append('image', image);

    const response = await axios({
      method: 'post', url: `${apiURI}/upload/uploadimage`, data: data,
      headers: { 'Authorization': 'Bearer ' + token }
    }).catch(e => console.log(e));

    return response.data
  }
 
  async postRegisterCategory(token, descriptionEnglish, descriptionItalian, descriptionPortugues, descriptionSpanish, imageid) {
    const bodyJson = {
      descriptionEnglish,
      descriptionItalian,
      descriptionPortugues,
      descriptionSpanish,
      imageid,
    }
   
    const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/register`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

    async getCategoryById(categoryId) {
    const response = await axios({
      method: 'get', url: `${apiURI}/product/category/getbyid/${categoryId}`
    });

    return response.data;

  }
  async getSubcategories(subCategoryId) {
    const response = await axios.get(`${apiURI}/product/category/subcategories/getbyidcategory/${subCategoryId}`)
    return response.data;
  }

  async getAttributes(token, username) {
    const response = await axios({ method: 'get', url: `${apiURI}/attribute/getbyuser/${username}`, headers: { 'Authorization': 'Bearer ' + token } });
    return response.data;
  }

   async postAttributeRegister(token, attribute, username) {
    const bodyJson = {
      attribute: attribute,
      username: username
    }

    const response = await axios({
      method: 'post', url: `${apiURI}/attribute/register`, data: bodyJson,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async postRegisterAttributeValue(token, attributeId, attributeValue, username) {
    const bodyJson = {
      attributevalue: attributeValue,
      idattribute: attributeId,
      username: username
    }

    const response = await axios({
      method: 'post', url: `${apiURI}/attribute/value/register`, data: bodyJson,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async getAttributeValues(token, attributeId, username) {
    const response = await axios({
      method: 'get', url: `${apiURI}/attribute/value/getbyattributeid/${username}/id/${attributeId}`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }


  async postEditCategory(token, descriptionEnglish, descriptionItalian, descriptionPortugues, descriptionSpanish, imageid, idcategory) {
    const bodyJson = {
      descriptionEnglish,
      descriptionItalian,
      descriptionPortugues,
      descriptionSpanish,
      idcategory,
      imageid,
    }

    const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/edit`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }


}